module.exports = __webpack_public_path__ + "static/media/mobileScreenshot05.66a17a93.jpg";